import { Box, styled, Theme } from '@planne-software/uni/mui/material';

export const LegendRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  width: '100%',
});

export const LegendItemsRow = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  rowGap: '0.5rem',
  width: '100%',
});

export const LegendItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  flexShrink: 0,
});

export const LegendLabel = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-regular'],
  color: theme.tokens.colors['text-color-neutral-strong']!,
}));

export type LegendSwatchVariant = 'available' | 'unavailable' | 'today';

const swatchStyle = (theme: Theme, variant: LegendSwatchVariant): React.CSSProperties => {
  const c = theme.tokens.colors;
  switch (variant) {
    case 'available':
      return { width: '1.25rem', height: '1rem', backgroundColor: c['fill-color-success-softest'] };
    case 'unavailable':
      return { width: '1.25rem', height: '1rem', backgroundColor: c['fill-color-neutral-softest'] };
    case 'today':
      return {
        width: '1rem',
        height: '1rem',
        backgroundColor: c['color-neutral-white'],
        border: `0.125rem solid ${theme.tokens.colors['fill-color-primary-base']!}`,
      };
  }
};

export const LegendSwatch = styled('span', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: LegendSwatchVariant }>(({ theme, variant }) => ({
  display: 'inline-block',
  borderRadius: '0.25rem',
  flexShrink: 0,
  position: 'relative',
  ...swatchStyle(theme, variant),
}));

export const LegendSwatchTodayDot = styled('span')(({ theme }) => ({
  display: 'block',
  position: 'absolute',
  left: '50%',
  top: '50%',
  width: '0.375rem',
  height: '0.375rem',
  transform: 'translate(-50%, -50%) rotate(45deg)',
  backgroundColor: theme.tokens.colors['fill-color-primary-base']!,
  pointerEvents: 'none',
}));

export const LegendDisclaimerRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '0.25rem',
});

export const LegendDisclaimerText = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-medium'],
  color: theme.tokens.colors['text-color-neutral-stronger'],
}));

export const LegendDisclaimerIconWrap = styled('span', {
  shouldForwardProp: (prop) => prop !== 'interactive',
})<{ interactive?: boolean }>(({ theme, interactive = false }) => ({
  display: 'inline-flex',
  color: theme.tokens.colors['text-color-neutral-stronger'],
  cursor: interactive ? 'help' : 'default',
}));
